export default __webpack_public_path__ + "static/media/refine-1.d551b6ff.webp";